import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { useMap } from 'react-leaflet';
import useSupercluster from 'use-supercluster';
import { DeviceModelMarker } from 'entities/device.map.marker-model/ui';
import { DeviceMarker } from 'console/entities/device.map.markers/ui';
import { a2l } from 'shared/map/lib/utils';
import { ClusterMarker } from 'widgets/map.cluster/ui/marker';
import { generateClusterPoints } from 'widgets/map.cluster/model/generate-points';
import { onDeviceMarkerClick } from 'console/entities/device.map.markers/lib';
export const DeviceMapCluster = memo(function DeviceMapCluster(props) {
    const { stationary_location_devices, location_devices, device_errors, onClickMarker, } = props;
    const points = useMemo(() => generateClusterPoints(stationary_location_devices, location_devices, device_errors), [stationary_location_devices, location_devices, device_errors]);
    const map = useMap();
    const b = map.getBounds();
    const { clusters, supercluster } = useSupercluster({
        points,
        bounds: [
            b.getSouthWest().lng,
            b.getSouthWest().lat,
            b.getNorthEast().lng,
            b.getNorthEast().lat,
        ],
        zoom: map.getZoom(),
    });
    return (_jsx(_Fragment, { children: clusters.map((cluster) => {
            const [longitude, latitude] = cluster.geometry.coordinates;
            const { cluster: isCluster, point_count: pointCount } = cluster.properties;
            if (isCluster) {
                return (_jsx(ClusterMarker, { position: [latitude, longitude], size: 10 + (pointCount / points.length) * 40, points: supercluster.getLeaves(cluster.id), onClick: () => {
                        const expansionZoom = Math.min(supercluster.getClusterExpansionZoom(cluster.id), 17);
                        map.setView([latitude, longitude], expansionZoom, {
                            animate: true,
                        });
                    } }, `cluster-${cluster.id}`));
            }
            if (cluster.properties.is_moved) {
                const marker = cluster.properties;
                return (_jsx(DeviceMarker, { position: a2l(marker.position), prev_position: marker.prev_position != null
                        ? a2l(marker.prev_position)
                        : a2l(marker.position), color: marker.color, icon_size: 50, name: marker.name, label_visible: true, onClick: onClickMarker
                        ? onDeviceMarkerClick(onClickMarker)(marker.id)
                        : undefined, online: marker.online }, cluster.properties.device_id));
            }
            return (_jsx(DeviceModelMarker, { position: [latitude, longitude], dev_loc: {
                    ...cluster.properties,
                    location: [latitude, longitude],
                }, errors: device_errors[parseInt(cluster.properties.device_id, 10)], onClick: (ev) => onClickMarker(parseInt(cluster.properties.device_id, 10), ev) }, cluster.properties.device_id));
        }) }));
});
